import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
} from '@angular/core';

@Component({
  selector: 'prlw-table-volume-progress-bar-ui',
  templateUrl: './volume-progress-bar.component.html',
  styleUrls: ['./volume-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VolumeProgressBarComponent {
  @Input() public progressData!: number[];

  constructor(private readonly elementRef: ElementRef) {}

  public get width(): number {
    return this.elementRef.nativeElement.clientWidth;
  }
}
